import './App.css';
import { useState } from 'react';
import Header from './components/header/Header';
import Analisys from './components/analisys/Analisys';
import Definition from './components/definition/Definition';
import Author from './components/author/Author';
import Opinions from './components/opinions/Opinions';
import SocialMedia from './components/socialMedia/SocialMedia';
import Footer from './components/footer/Footer';
import Impressum from './components/legal/Impressum';
import Datenschutz from './components/legal/Datenschutz';

function App() {
  const [currentPage, setCurrentPage] = useState('main');

  const renderContent = () => {
    switch(currentPage) {
      case 'impressum':
        return (
          <Impressum 
            onBack={() => setCurrentPage('main')} 
            onShowDatenschutz={() => setCurrentPage('datenschutz')}
          />
        );
      case 'datenschutz':
        return (
          <Datenschutz 
            onBack={() => setCurrentPage('main')} 
            onShowImpressum={() => setCurrentPage('impressum')}
          />
        );
      default:
        return (
          <>
            <div className='header-container'>
              <Header />
              <Analisys/>
            </div>
            <Definition />
            <Author />
            <Opinions />
            <SocialMedia />
            <Footer 
              currentPage={currentPage}
              onShowImpressum={() => setCurrentPage('impressum')} 
              onShowDatenschutz={() => setCurrentPage('datenschutz')} 
            />
          </>
        );
    }
  };

  return (
    <div className="App">
      {renderContent()}
    </div>
  );
}

export default App;